import lazyLoading from './lazyLoading'

export default {
  name: 'Catalog',
  meta: {
    expanded: false,
    title: 'menu.catalog.parent',
    iconClass: 'vuestic-icon vuestic-icon-forms'
  },
  children: [
    {
      name: 'SizeList',
      path: '/catalog/sizes/list',
      component: lazyLoading('sizes/List'),
      meta: {
        title: 'menu.catalog.sizeList'
      }
    },
    {
      name: 'ColorList',
      path: '/catalog/colors/list',
      component: lazyLoading('colors/List'),
      meta: {
        title: 'menu.catalog.colorList'
      }
    },
    {
      name: 'CategoryList',
      path: '/catalog/categories/list',
      component: lazyLoading('categories/List'),
      meta: {
        title: 'menu.catalog.categoryList'
      }
    },
    {
      name: 'BrandList',
      path: '/catalog/brands/list',
      component: lazyLoading('brands/List'),
      meta: {
        title: 'menu.catalog.brandList'
      }
    },
    {
      name: 'ProductList',
      path: '/catalog/products/list',
      component: lazyLoading('products/List'),
      meta: {
        title: 'menu.catalog.productList'
      }
    },
    {
      name: 'VariantList',
      path: '/catalog/variants/list',
      component: lazyLoading('variants/List'),
      meta: {
        title: 'menu.catalog.variantList'
      }
    },
    {
      name: 'SizeCreate',
      path: '/catalog/sizes/create',
      component: lazyLoading('sizes/Form'),
      meta: {
        title: 'menu.catalog.sizeCreate'
      },
      hidden: true
    },
    {
      name: 'ColorCreate',
      path: '/catalog/colors/create',
      component: lazyLoading('colors/Form'),
      meta: {
        title: 'menu.catalog.colorCreate'
      },
      hidden: true
    },
    {
      name: 'CategoryCreate',
      path: '/catalog/categories/create',
      component: lazyLoading('categories/Form'),
      meta: {
        title: 'menu.catalog.categoryCreate'
      },
      hidden: true
    },
    {
      name: 'BrandCreate',
      path: '/catalog/brands/create',
      component: lazyLoading('brands/Form'),
      meta: {
        title: 'menu.catalog.brandCreate'
      },
      hidden: true
    },
    {
      name: 'ProductCreate',
      path: '/catalog/products/create',
      component: lazyLoading('products/Form'),
      meta: {
        title: 'menu.catalog.productCreate'
      },
      hidden: true
    },
    {
      name: 'VariantCreate',
      path: '/catalog/variants/create',
      component: lazyLoading('variants/Form'),
      meta: {
        title: 'menu.catalog.variantCreate'
      },
      hidden: true
    },
    {
      name: 'SizeEdit',
      path: '/catalog/sizes/edit/:id',
      component: lazyLoading('sizes/Form'),
      meta: {
        title: 'menu.catalog.sizeEdit'
      },
      hidden: true
    },
    {
      name: 'ColorEdit',
      path: '/catalog/colors/edit/:id',
      component: lazyLoading('colors/Form'),
      meta: {
        title: 'menu.catalog.colorEdit'
      },
      hidden: true
    },
    {
      name: 'CategoryEdit',
      path: '/catalog/categories/edit/:id',
      component: lazyLoading('categories/Form'),
      meta: {
        title: 'menu.catalog.categoryEdit'
      },
      hidden: true
    },
    {
      name: 'BrandEdit',
      path: '/catalog/brands/edit/:id',
      component: lazyLoading('brands/Form'),
      meta: {
        title: 'menu.catalog.brandEdit'
      },
      hidden: true
    },
    {
      name: 'ProductEdit',
      path: '/catalog/products/edit/:id',
      component: lazyLoading('products/Form'),
      meta: {
        title: 'menu.catalog.productEdit'
      },
      hidden: true
    },
    {
      name: 'VariantEdit',
      path: '/catalog/variants/edit/:id',
      component: lazyLoading('variants/Form'),
      meta: {
        title: 'menu.catalog.variantEdit'
      },
      hidden: true
    },
  ]
}



// WEBPACK FOOTER //
// ./src/store/modules/menu/catalog.js